// import React, { useEffect } from 'react';
// import UpperLeftGreenpillSection from './UpperLeftGreenpillSection';
// import noPillSelected from '../../assets/greenpill/noPillSelected.png';
// import { useHome } from '../../contexts/HomeContext';
// import { getAchievmentImpactPoints } from '../../apis/geenpills/apis';
// import ProgressBar from '../../ui/ProgressBar';
// import SelectPrimaryPill from './SelectPrimaryPill';
// import HoveredToast from '../../ui/HoveredToast';

// const UpperGreenpillSection = () => {
//     const { state: homeState } = useHome();
//     useEffect(function () {
//         const fetchData = async () => {
//             try {
//                 const response = await getAchievmentImpactPoints();
//                 console.log(response, 'aaya kya');
//             } catch (error) {
//                 return null;
//             }
//         };

//         fetchData();
//     }, []);

//     console.log(homeState?.selectedPill, 'see the selected pill here');
//     return (
//         <div className="">
//             <div className="flex  flex-col-reverse lg:flex-row   w-full ">
//                 <div className=" w-full lg:w-[70%] rounded-t-3xl lg:rounded-none  bg-[#272727] md:bg-inherit p-4  md:p-0  gap-6">
//                     <UpperLeftGreenpillSection />
//                 </div>

//                 <div className=" w-full lg:w-[30%] relative  bg-mint-mobile-gradient  rounded-t-3xl lg:rounded-t-none  md:bg-none">
//                     <div className="w-full h-[35rem] relative ">
//                         <div className="w-[30%] lg:w-full  md:h-full  flex   justify-center">
//                             <img
//                                 className="h-[16.56rem]  lg:h-full object-cover"
//                                 src={homeState?.selectedPill ? homeState?.selectedPill?.imageURI : noPillSelected}
//                                 alt="Red NFT"
//                             />
//                         </div>
//                         <HoveredToast points={1400} className="top-[50%] translate-y-[-50%] -left-[60%]  " />
//                     </div>

//                     <div className="flex flex-col gap-4 items-center justify-center">
//                         <SelectPrimaryPill />
//                         <div className="w-[12.5rem]">
//                             <div className="flex items-center justify-between">
//                                 <p className="font-bold text-foundryYellowL">-</p>
//                                 <p className="font-bold text-foundryYellowL">-</p>
//                             </div>

//                             <ProgressBar color={'bg-[#888]'} width={100 + '%'} />
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default UpperGreenpillSection;

import React, { useEffect, useState } from 'react';
import UpperLeftGreenpillSection from './UpperLeftGreenpillSection';
import noPillSelected from '../../assets/greenpill/noPillSelected.png';
import { useHome } from '../../contexts/HomeContext';
import { getAchievmentImpactPoints } from '../../apis/geenpills/apis';
import ProgressBar from '../../ui/ProgressBar';
import SelectPrimaryPill from './SelectPrimaryPill';
import HoveredToast from '../../ui/HoveredToast';
import { getPillProgress } from '../../apis/geenpills/getPillProgress';
import { fundText, getColor } from '../../helpers/greenPillHelper';
import { useLoadingState } from '../../hooks/useLoader';
import Loader from '../../ui/Loader';
import { getImpactPointsUnused } from '../../apis/geenpills/getImpactPointsUnused';
import DuplicateBountyModal from '../bounties/DuplicateBountyModal';
import PrimaryPillConfirmation from './PrimaryPillConfirmation';
import { formatNumber } from '../../helpers/formatNumber';

const UpperGreenpillSection = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [foundPill, setFoundPill] = useState(null);
    const [isSetNew, setIsSetNew] = useState(false);
    const { state: homeState, dispatch, loading, fetchData: fetchNFTData } = useHome();
    const {
        loading: gettingAdditionalPillDetails,
        startLoading: startGettingAdditionalPillDetails,
        stopLoading: stopGettingAdditionalPillDetails,
    } = useLoadingState();
    const [additionalPillDetails, setAdditionalPillDetails] = useState([]);
    const { greenPillNFTsHoldByWalletAddress } = homeState;

    // useEffect(() => {
    //     const fetchData = async () => {
    //         try {
    //             console.log('fetching data of nft id');
    //             startGettingAdditionalPillDetails();
    //             const [response1, response2] = await Promise.all([
    //                 getImpactPointsUnused(),
    //                 getPillProgress(homeState?.selectedPill?.nftId),
    //             ]);
    //             console.log('fetching data of nft id bro', 'check here', response1, response2, homeState?.selectedPill);
    //             setAdditionalPillDetails({ ...response2, ...response1 });
    //         } catch (error) {
    //             return null;
    //         } finally {
    //             stopGettingAdditionalPillDetails();
    //         }
    //     };
    //     console.log('fetching data of nft id', homeState?.selectedPill);
    //     if (homeState?.selectedPill?.nftId) fetchData();
    // }, [homeState?.selectedPill?.nftId]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                startGettingAdditionalPillDetails();
                const [response1, response2] = await Promise.all([
                    getImpactPointsUnused(),
                    getPillProgress(homeState?.selectedPill?.nftId),
                ]);
                console.log(response1, response2, 'check here');
                setAdditionalPillDetails({ ...response2, ...response1 });
            } catch (error) {
                return null;
            } finally {
                stopGettingAdditionalPillDetails();
            }
        };

        let timeoutId;
        console.log(homeState?.selectedPill?.nftId, homeState, 'what is sceneario');
        if (homeState?.selectedPill?.nftId) {
            if (isSetNew) {
                // timeoutId = setTimeout(() => {
                fetchNFTData();
                fetchData();
                // }, 5000);
            } // 10 seconds
            else {
                fetchData();
            }
        }

        return () => {
            // clearTimeout(timeoutId); // clean up on unmount or id change
        };
    }, [homeState?.selectedPill?.nftId, isSetNew]);

    const imageSrc = homeState?.selectedPill?.imageURI || noPillSelected;
    console.log(additionalPillDetails, 'use this additional pill');

    return (
        <div>
            <div className="flex flex-col-reverse lg:flex-row w-full">
                <div className="w-full lg:w-[70%] rounded-t-3xl lg:rounded-none bg-[#272727] md:bg-inherit p-4 md:p-0 gap-6">
                    <UpperLeftGreenpillSection pillDetails={additionalPillDetails} />
                </div>

                <div className="w-full lg:w-[30%] relative bg-mint-mobile-gradient rounded-t-3xl lg:rounded-t-none md:bg-none">
                    <div className="w-full h-[35rem] relative">
                        <div
                            className="w-[30%] lg:w-full md:h-full flex cursor-pointer justify-center relative"
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                        >
                            <img className="h-[16.56rem] lg:h-full object-cover" src={imageSrc} alt="Red NFT" />

                            {isHovered && greenPillNFTsHoldByWalletAddress.length > 0 && homeState?.selectedPill && (
                                <HoveredToast
                                    points={
                                        Number(additionalPillDetails?.progress) < 1800
                                            ? 1800 - Number(additionalPillDetails?.progress)
                                            : 3600 - Number(additionalPillDetails?.progress)
                                    }
                                    className="absolute z-[9999] top-[50%] translate-y-[-50%] -left-[60%]"
                                />
                            )}
                        </div>
                    </div>

                    <div className="flex flex-col gap-4 items-center justify-center">
                        <SelectPrimaryPill foundPill={foundPill} setFoundPill={setFoundPill} />
                        {gettingAdditionalPillDetails ? (
                            <Loader />
                        ) : (
                            <div className="w-[12.5rem]">
                                <div className="flex items-center justify-between">
                                    <p
                                        className={`font-semibold ${
                                            fundText[getColor(Number(additionalPillDetails?.progress || 0))]?.text
                                        } `}
                                    >
                                        {homeState?.selectedPill
                                            ? ((Number(additionalPillDetails?.progress || 0) / 3600) * 100)?.toFixed(
                                                  2
                                              ) + '%'
                                            : '-'}
                                    </p>
                                    <p
                                        className={`font-semibold ${
                                            fundText[getColor(Number(additionalPillDetails?.progress || 0))]?.text
                                        } `}
                                    >
                                        {homeState?.selectedPill
                                            ? formatNumber(Number(additionalPillDetails?.progress || 0)) + '/3.60K IP'
                                            : '-'}
                                    </p>
                                </div>
                                <ProgressBar
                                    bgDefault="bg-[#ADADAD]"
                                    color={fundText[getColor(Number(additionalPillDetails?.progress))]?.progress}
                                    width={
                                        ((Number(additionalPillDetails?.progress || 0) / 3600) * 100)?.toFixed(2) + '%'
                                    }
                                />
                            </div>
                        )}
                    </div>
                </div>
                {foundPill && (
                    <PrimaryPillConfirmation
                        close={() => setFoundPill(null)}
                        foundPill={foundPill}
                        extraIPs={formatNumber(additionalPillDetails?.impactPointsUnused)}
                        handleConfirmAction={async (close, stopLoading) => {
                            try {
                                setIsSetNew(true);
                                close();
                                stopLoading();
                                // startGettingAdditionalPillDetails();

                                // const [response1, response2] = await Promise.all([
                                //     getImpactPointsUnused(),
                                //     getPillProgress(homeState?.selectedPill?.nftId),
                                // ]);
                                // setAdditionalPillDetails({ ...response2, ...response1 });
                            } catch (error) {
                                return null;
                            } finally {
                                stopGettingAdditionalPillDetails();
                            }
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export default UpperGreenpillSection;
